import Axios from 'axios'
import { getCookie } from '../utils/auth-utils'
var qs = require('qs')

const sample = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  getAllSamples(
    offset,
    limit,
    status,
    startDate,
    endDate,
    orderBy,
    q,
    dateType,
    patientName,
    batchLabel,
    codeOriginLis,
    codeOriginAlvaro,
    idFile,
    packagingType,
    integrated,
    docDelivered,
    processingOrigin,
    idRecollect,
    collectionPointName,
    printed,
    tab,
  ) {
    let endPoint = '/sample'
    if (tab === 'aolWs') endPoint += '/aolws'
    return this.axios().get(endPoint, {
      params: {
        limit: limit,
        offset: offset * limit,
        status: status,
        startDate: startDate,
        endDate: endDate,
        orderBy: orderBy,
        query: q,
        dateType: dateType,
        patientName: patientName,
        batchLabel: batchLabel,
        codeOriginLis: codeOriginLis,
        codeOriginAlvaro: codeOriginAlvaro,
        idFile: idFile,
        packagingType: packagingType,
        integrated: integrated,
        docDelivered: docDelivered,
        XmlOrder: getCookie('toggleAol').feature.sortByFile,
        processingOrigin: processingOrigin,
        idRecollect: idRecollect,
        collectionPointName,
        printed
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, {
          indices: false
        })
      }
    })
  },
  printTag (sampleIds, printBatch, source) {
    if (source === 'AOLWS') {
      return this.axios().post('/sample/aolws/print', sampleIds)
    }
    return this.axios().post('/order/print', sampleIds, {
      params: {
        print_batch: printBatch
      }
    })
  },
  printReceipt (items) {
    return this.axios().post('/report/sorted-order-transfer-receipt', items, {
      responseType: 'arraybuffer'
    })
  },
  countTotalSample (params) {
    return this.axios().post('/sample/samples-count', params)
  },
  aolwsSampleByBatch (id) {
    return this.axios().get('/sample/aolws/' + id)
  }
}

export default sample
